import React from 'react'

import { Icon } from '../../../components/UI'

const FiltersTag = ({ text, onDelete }) => {
  return (
    <li className="flex justify-center items-center rounded-full h-[36px] px-[12px] bg-[#FEEBDD] shadow-button-second">
      <span className="text-md text-primary-100 font-medium mr-[4px]">{text}</span>

      <button aria-label={`Delete filter: ${text}`} onClick={onDelete}>
        <Icon name="close" color="#F67443" className="w-[20px] h-[20px]" />
      </button>
    </li>
  )
}

export default FiltersTag
